export const DEDICATED_LANE_SEARCH_PAGE_SCROLL_Y = 'dedicatedLaneSearchPageScrollY'

export const DEFAULT_RADIUS = 50

export const optionsMulti = [
  { value: 'dry_van', label: 'Dry Van', selected: false },
  { value: 'reefer', label: 'Reefer', selected: false },
  { value: 'open_deck', label: 'Flatbed', selected: false },
]
